import React, { useState, useEffect } from "react";
import {
  View,
  Text,
  TextInput,
  TouchableOpacity,
  StyleSheet,
  Modal,
} from "react-native";
import { useTranslation } from "react-i18next";

import Colors from "../../../Resources/Color";
import Fonts from "../../../Resources/Fonts";
import GlobalStyles from "../../../Resources/Styles";
import { useDevice } from "../../_layout";

const EditMacroView = ({ isVisible, onClose, initialLabel = "", onSave }) => {
  const { t } = useTranslation();
  const { isMobile } = useDevice();

  const [macroName, setMacroName] = useState(initialLabel);
  const [isNameHovered, setIsNameHovered] = useState(false);

  const [isSaveHovered, setIsSaveHovered] = useState(false);
  const [isCancelHovered, setIsCancelHovered] = useState(false);

  useEffect(() => {
    if (isVisible) setMacroName(initialLabel);
  }, [isVisible, initialLabel]);

  const cancel = () => {
    setMacroName(initialLabel);
    onClose?.();
  };

  const handleSave = () => {
    if (typeof onSave === "function") {
      onSave(macroName);
    } else {
      console.log("Save macro name:", macroName);
    }
    onClose?.();
  };

  return (
    <Modal
      animationType="fade"
      transparent
      visible={isVisible}
      onRequestClose={onClose}
    >
      <View style={GlobalStyles.centeredView}>
        <TouchableOpacity
          onPress={onClose}
          style={GlobalStyles.touchableBackground}
        >
          <View />
        </TouchableOpacity>

        <View
          style={{ position: "absolute" }}
          onStartShouldSetResponder={() => false}
        >
          <View style={[styles.modalView, { width: 360 }]}>
            <View style={{ width: "100%", alignItems: "center" }}>
              <Text style={Fonts.bold18Centered}>{t("editMacro-string")}</Text>

              <TextInput
                style={[
                  GlobalStyles.textInputStyle,
                  {
                    borderRadius: 10,
                    borderColor: isNameHovered
                      ? "rgba(0, 0, 0, 0.5)"
                      : Colors.borderColor,
                  },
                ]}
                placeholder={initialLabel || t("label-string")}
                placeholderTextColor={Colors.grayColor}
                value={macroName}
                onChangeText={setMacroName}
                maxLength={40}
                onMouseEnter={() => !isMobile && setIsNameHovered(true)}
                onMouseLeave={() => setIsNameHovered(false)}
                autoFocus
              />

              <View
                style={{
                  width: "100%",
                  flexDirection: "row",
                  justifyContent: "space-evenly",
                  marginTop: 16,
                }}
              >
                <TouchableOpacity
                  onPress={cancel}
                  onMouseEnter={() => !isMobile && setIsCancelHovered(true)}
                  onMouseLeave={() => setIsCancelHovered(false)}
                >
                  <View
                    style={{
                      backgroundColor: isCancelHovered
                        ? Colors.redColor
                        : Colors.whiteColor,
                      borderRadius: 14,
                      borderWidth: 1,
                      borderColor: "red",
                      width: 80,
                      height: 35,
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <Text
                      style={{
                        color: isCancelHovered
                          ? Colors.whiteColor
                          : Colors.redColor,
                      }}
                    >
                      {t("cancel-string")}
                    </Text>
                  </View>
                </TouchableOpacity>

                <TouchableOpacity
                  onPress={handleSave}
                  onMouseEnter={() => !isMobile && setIsSaveHovered(true)}
                  onMouseLeave={() => setIsSaveHovered(false)}
                >
                  <View
                    style={{
                      backgroundColor: Colors.bubbleColor,
                      borderRadius: 14,
                      borderWidth: 1,
                      borderColor: Colors.bubbleColor,
                      width: 80,
                      height: 35,
                      justifyContent: "center",
                      alignItems: "center",
                      opacity: isSaveHovered ? 0.8 : 1,
                    }}
                  >
                    <Text style={{ color: Colors.whiteColor }}>
                      {t("save-string")}
                    </Text>
                  </View>
                </TouchableOpacity>
              </View>
            </View>
          </View>
        </View>
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  modalView: {
    backgroundColor: Colors.whiteColor,
    borderRadius: 18,
    paddingHorizontal: 24,
    paddingVertical: 24,
    alignItems: "center",
    justifyContent: "space-between",
  },
});

export default EditMacroView;
